<script setup lang="ts">
const { t } = useEkI18n();
const settingsStore = useSettingsStore();

async function updateStartToday(value: boolean) {
  await settingsStore.set('showWorksheetsToday', value);
}
</script>

<template>
  <SettingsToggle
    :checked="settingsStore.settings.showWorksheetsToday"
    :label="t('settings.worksheets.startToday')"
    :description="t('settings.worksheets.startTodayDescription')"
    @change="updateStartToday"
  />
</template>

<style scoped></style>
